import { ConnectionSetting } from 'common/types/kraken-core/ConnectionSettings'
import { ImportOrUpdateConnectionSettingAPIPayload } from 'pages/Connections/types'
import { ConnectionSettingFromImportedGatewaySetting } from 'pages/Gateway/types'

/**
 * Extracts the owner ID from a connection setting's owner property
 * The owner can be either a string (ID) or an object with { id: string; name: string }
 */
export const getConnectionOwnerId = (connection: ConnectionSetting): string => {
  if (!connection?.owner) return ''

  if (typeof connection.owner === 'string') {
    return connection.owner
  }

  if (typeof connection.owner === 'object' && connection.owner?.id) {
    return connection.owner.id
  }

  return ''
}

/**
 * Extracts the owner name from a connection setting's owner property
 * The owner can be either a string (ID) or an object with { id: string; name: string }
 */
export const getConnectionOwnerName = (connection: ConnectionSetting): string => {
  if (!connection?.owner) return ''

  if (typeof connection.owner === 'string') {
    return '' // No name available when owner is just a string ID
  }

  if (typeof connection.owner === 'object' && connection.owner?.name) {
    return connection.owner.name
  }

  return ''
}

/**
 * Maps the owner property to the owner_id property, which is expected by the API
 * for creating or updating a connection setting.
 */
export const mapConnectionPropOwnerToOwnerId = (
  payload: ConnectionSetting | ConnectionSettingFromImportedGatewaySetting
): ImportOrUpdateConnectionSettingAPIPayload => {
  const { owner, ...restPayload } = payload

  const owner_id =
    payload.owner && typeof payload.owner === 'string'
      ? payload.owner
      : payload.owner && typeof payload.owner === 'object' && payload.owner.id
      ? payload.owner.id
      : undefined

  return {
    ...restPayload,
    owner_id,
  }
}
